import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { StateService } from '../../app-states/state.service';
import { Lab } from '../../contracts/lab/lab.model';
import { Utility } from '../../core/helpers/utility';
import { AccessControlService, GetResourcePermissionsByKey } from '../../core/security/access-control';

const noLabSelectedRoute = '/no-lab-selected';

@Injectable()
export class LabGuard {
  constructor(private state: StateService,
    private router: Router,
    private accessControl: AccessControlService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const routeLabId = route.params['labId'];
    return this.isLabSelected(routeLabId).map((isSelected) => {
      if (isSelected) {
        return true;
      } else {
        this.router.navigate([noLabSelectedRoute]);
        return false;
      }
    });
  }

  public isLabSelected(routeLabId): Observable<boolean> {
    const isLabSelected = false;
    const currentLab = this.state.getCurrentLab();
    if (currentLab && currentLab.id > 0) {
      return Observable.of(true);
    }
  }

  public hasAccessToLabIfExpired(currentLab: Lab) {
    const rp = GetResourcePermissionsByKey('AccessExpiredLab');

    // If no AccessExpiredLab permission, but not expired, allow access.
    return this.accessControl.HasUserAccess(rp)
        || (!Utility.isDateExpired(currentLab.licenseExpirationDate));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/guards/lab-guard.service.ts